import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import csAdmin from './locales/cs/admin.json';
import csCommon from './locales/cs/common.json';
import csDocuments from './locales/cs/documents.json';
import csReview from './locales/cs/review.json';
import enAdmin from './locales/en/admin.json';
import enCommon from './locales/en/common.json';
import enDocuments from './locales/en/documents.json';
import enReview from './locales/en/review.json';

/**
 * One file per feature and language, each with a single top-level namespace key
 * (`common`, `nav`, `auth`, `documents`, `review`, `admin`), merged into the one
 * `translation` namespace i18next serves. Features therefore add keys without touching each
 * other's files.
 */
const cs = { ...csCommon, ...csDocuments, ...csReview, ...csAdmin };
const en = { ...enCommon, ...enDocuments, ...enReview, ...enAdmin };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      cs: { translation: cs },
      en: { translation: en },
    },
    // Czech is the customer's language; English is the fallback for anything untranslated.
    fallbackLng: 'cs',
    supportedLngs: ['cs', 'en'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Only the user's own choice is detected. The application is a Czech internal tool, so a
      // browser that happens to report another language must not turn the interface English;
      // `fallbackLng` above is what an unvisited browser gets, and the switcher persists a choice.
      order: ['localStorage'],
      lookupLocalStorage: 'sdd.language',
      caches: ['localStorage'],
    },
  });

export default i18n;
